/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import styled from "@emotion/styled";
import { colors, Title1 } from "@utils/ui_palette";
import { rgba } from "emotion-rgba";

interface IModule {
  id: number;
  question: string;
  anwser: string;
  choice: string[] | null;
  question_image: null | string;
  score: number;
  answer_submit: string;
  answer_s3: string;
  answer_id: string;
}

interface IModal {
  item: IModule | null;
  type: string | null;
  callback: (item: IModule, type: string, answer: string | number) => void;
  handleModal: (state: boolean) => void;
}

function CountModal({ item, type, callback, handleModal }: IModal) {
  const [currentPoint, setPoint] = useState<number | null>(null);
  const points = [0, 1, 2, 3, 4, 5];

  const handlePoint = useCallback(
    (value: number) => {
      setPoint(value);
    },
    [setPoint]
  );

  const closeModal = useCallback(() => {
    handleModal(false);
  }, []);

  const handleSubmit = useCallback(() => {
    if (item && type) {
      closeModal();

      if (currentPoint && type === "Make_the_sentence") {
        callback(item, type, currentPoint);
        return;
      }

      if (type === "Letter_name" || type === "Letter_sound") {
        callback(item, type, 61);
        return;
      }
      callback(item, type, item.anwser);
    }
  }, [currentPoint]);

  return (
    <Modals>
      <ModalBody>
        {item && type && (
          <>
            <Title1>{type}</Title1>
            <Contents>
              <Question>{item.question}</Question>

              <ContentsBox>
                {item.answer_s3 !== "" && (
                  <Audio src={item.answer_s3} controls />
                )}
              </ContentsBox>
              {type === "Make_the_sentence" && (
                <ScoreBox>
                  {points.map((point) => (
                    <Score
                      key={point}
                      active={currentPoint === point}
                      onClick={() => handlePoint(point)}
                    >
                      {point} point
                    </Score>
                  ))}
                </ScoreBox>
              )}
            </Contents>
          </>
        )}
        {item && type && (
          <ButtonGroup>
            {type === "Make_the_sentence" ? (
              <ConfirmButton
                onClick={handleSubmit}
                active={currentPoint ? false : true}
                disabled={currentPoint ? false : true}
              >
                Submit
              </ConfirmButton>
            ) : (
              <ConfirmButton
                onClick={handleSubmit}
                active={
                  item.anwser.toLowerCase() === item.answer_submit.toLowerCase()
                }
                disabled={
                  item.anwser.toLowerCase() === item.answer_submit.toLowerCase()
                }
              >
                Anwser
              </ConfirmButton>
            )}

            <CancelButton onClick={closeModal}>Cancel</CancelButton>
          </ButtonGroup>
        )}
      </ModalBody>
    </Modals>
  );
}

const Modals = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: ${rgba(colors.Black, 0.5)};
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  width: 900px;
  padding: 30px;
  background-color: ${colors.White};
  border-radius: 15px;
`;

const Contents = styled.div``;

const Audio = styled("audio")`
  width: 100%;
`;

const ContentsBox = styled.div`
  flex-basis: calc(50% - 20px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Question = styled.div`
  padding: 20px;
  font-size: 36px;
  border: 1px solid ${colors.Black};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px auto;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 80px;
`;

const ConfirmButton = styled.button<{ active: boolean }>`
  flex-basis: calc(50% - 10px);
  height: 50px;
  outline: 0;
  border: 0;
  background-color: ${(props) =>
    props.active ? colors.Gray30 : colors.Primary50};
  border-radius: 8px;
  color: ${colors.White};
  cursor: ${(props) => (props.active ? "not-allowed" : "pointer")};
`;

const CancelButton = styled.button`
  flex-basis: calc(50% - 10px);
  height: 50px;
  outline: 0;
  border: 1px solid ${colors.Black};
  background-color: ${colors.White};
  border-radius: 8px;
  color: ${colors.Black};
  cursor: pointer;
`;

const ScoreBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
`;

const Score = styled.div<{ active: boolean }>`
  flex: 1;
  margin: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.active ? colors.Primary50 : colors.White};
  color: ${(props) => (props.active ? colors.White : colors.Gray50)};
  border: 1px solid ${(props) => (props.active ? colors.White : colors.Gray50)};
  font-size: 18px;
  height: 50px;
  border-radius: 10px;
  cursor: pointer;
`;

export default CountModal;
